module.exports = __webpack_public_path__ + "static/media/icon-chevon-right.1138874e.svg";